import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MockTestData } from '../../models/MockTestData';

interface TestState {
  selectedTest: MockTestData | null;
}

// Load initial state from localStorage
const loadSelectedTestFromStorage = (): MockTestData | null => {
  try {
    const savedTest = localStorage.getItem('selectedTest');
    return savedTest ? JSON.parse(savedTest) : null;
  } catch (error) {
    return null;
  }
};

const initialState: TestState = {
  selectedTest: loadSelectedTestFromStorage(),
};

const testSlice = createSlice({
  name: 'test',
  initialState,
  reducers: {
    selectTest: (state, action: PayloadAction<MockTestData>) => {
      state.selectedTest = action.payload;
      // Remove localStorage - handled by redux-persist
      // try {
      //   localStorage.setItem('selectedTest', JSON.stringify(action.payload));
      // } catch (error) {
      // }
    },
    clearSelectedTest: (state) => {
      state.selectedTest = null;
      // Remove localStorage - handled by redux-persist
      // try {
      //   localStorage.removeItem('selectedTest');
      // } catch (error) {
      // }
    },
  },
});

export const { selectTest, clearSelectedTest } = testSlice.actions;
export default testSlice.reducer;